export default __webpack_public_path__ + "static/media/padlock-open.db438108.svg";